module.exports = __webpack_public_path__ + "resources/img/solution_game_kr.5ebaab16a6cecf29bb6cb62ffa3e9f99.png";